import { store } from "@store";
import { Step, Values } from "../types";

function getName({
  type,
  users = [],
  systems = [],
}: Partial<Values>): Step["name"] | undefined {
  if (type && users.length && systems.length) {
    return "summary";
  } else if (!type) {
    return "type";
  } else if (!users.length) {
    return "user-information";
  } else if (!systems.length) {
    return "system-details";
  }
}

function getView(
  name: Step["name"] | undefined,
  { users = [], systems = [] }: Partial<Values>
): Step["view"] | undefined {
  if (name) {
    const { user } = store.getState();

    switch (name) {
      case "type":
        return "select-type";
      case "user-information":
        return !users.length ||
          (users.length === 1 && users[0].email === user?.email)
          ? "select-target"
          : "users-list";
      case "system-details":
        return !systems.length ? "select-systems" : "systems-list";
      case "summary":
        return "summary";
    }
  }
}

export function getInitialStep(values: Partial<Values>): Step {
  const name = getName(values);
  const view = getView(name, values);

  if (!name || !view) {
    throw new Error("Unknown step");
  }

  return {
    name,
    view,
  };
}
